declare var window: any

export default function waitForAnalytics(callback: () => void): any {
  if (!window.analytics) return setTimeout(() => waitForAnalytics(callback), 300)

  window.analytics.ready(callback)
}
